import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IconService {

  favIcon: HTMLLinkElement | null = document.querySelector('#favicon');

  constructor() { }

  setIcon(src?: string): void {
    if (!this.favIcon) return
    this.favIcon.href = src ?? './assets/icons/desktop.ico';
    this.favIcon.type = "image/svg+xml";
  }

  resetIcon(): void {
    if (!this.favIcon) return
    this.favIcon.href = 'favicon.ico';
  }

}
